// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"password__gradient-bg5__Q1yvA","errorText":"password__errorText__BycqS"};